import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SocialService, SocialPost, PostStatus } from '../../../services/social.service';
import { MatDialog } from '@angular/material/dialog';
import { SocialReplyDialogComponent } from '../dialogs/social-reply-dialog/social-reply-dialog.component';
import { TemaService } from 'src/app/services/tema.services';
import { Subscription } from 'rxjs';
import { SseService } from 'src/app/services/SseService';


@Component({
  selector: 'app-social-list',
  templateUrl: './social-list.component.html',
  styleUrls: ['./social-list.component.scss']
})
export class SocialListComponent implements OnInit, OnDestroy {

  posts: SocialPost[] = [];
  allPosts: SocialPost[] = [];

  loading = false;
  statusFilter: PostStatus | null = null;
  page = 0;
  size = 20;
  totalPages = 0;
  totalElements = 0;
  expandedPostId: number | null = null;
  private refreshTimer: any;
  isDark = false;
  theme = 'light-theme';
   private subTemaService?: Subscription;
  selectedNetwork: string | null = null;
  selectedDate: string | null = null; 
expandedComments = new Set<string>();
  readonly networkLabels: { [key: string]: string } = {
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    LINKEDIN: 'LinkedIn',
    TWITTER: 'Twitter',
    YOUTUBE: 'YouTube',
    TIKTOK: 'TikTok'
  };

  constructor(
    private socialService: SocialService,
    private router: Router,
    private temaService: TemaService,
    private dialog: MatDialog,
     private sseService: SseService,
  ) {}

  ngOnInit(): void {
    this.loadPosts();
    // auto-refresh cada 10s si hay posts en estado PUBLISHING
    this.refreshTimer = setInterval(() => {
      if (this.posts.some(p => p.status === 'PUBLISHING' || p.status === 'SCHEDULED')) {
        this.loadPosts(true);
      }
    }, 10000);
    this.subTemaService = this.temaService.valDarkTheme.subscribe({
      next: (data: boolean) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subTemaService) {
      this.subTemaService.unsubscribe();
    }
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  }

  loadPosts(silent: boolean = false): void {
    if (!silent) this.loading = true;
    this.socialService.listPosts(this.statusFilter, this.page, this.size).subscribe({
      next: (res) => {
        this.allPosts = JSON.parse(JSON.stringify(res.content));
        this.posts = JSON.parse(JSON.stringify(res.content));
        this.applyFilters();
        this.totalPages = res.totalPages;
        this.totalElements = res.totalElements;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error cargando posts', err);
        this.loading = false;
      }
    });
  }
applyFilters(): void {

  console.log('🔎 aplicando filtros');

  // 🔥 caso: sin filtro → mostrar todo
  if (!this.selectedNetwork) {
    this.posts = structuredClone(this.allPosts);
    return;
  }

  const filtered = this.allPosts
    .filter(post => {

      // 🔥 validar si el post tiene esa red
      return post.targets?.some(t =>
        t.network === this.selectedNetwork
      );

    })
    .map(post => {

      return {
        ...post,

        // 🔥 solo mostrar targets de la red seleccionada
        targets: post.targets?.filter(t =>
          t.network === this.selectedNetwork
        ) || [],

        // opcional: mantener comentarios intactos
        commentList: post.commentList || []

      };

    });

  this.posts = structuredClone(filtered);
}

  onFilterChange(status: PostStatus | null): void {
    this.statusFilter = status;
    this.page = 0;
    this.loadPosts();
  }

  nextPage(): void {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.loadPosts();
    }
  }

  prevPage(): void {
    if (this.page > 0) {
      this.page--;
      this.loadPosts();
    }
  }

  newPost(): void {
    this.router.navigate(['/social/new']);
  }

  goToAccounts(): void {
    this.router.navigate(['/social/accounts']);
  }

  editPost(post: SocialPost): void {
    this.router.navigate(['/social', post.postId, 'edit']);
  }

  cancelPost(post: SocialPost): void {
    if (!confirm('¿Cancelar esta publicación programada?')) return;
    this.socialService.cancelPost(post.postId).subscribe({
      next: () => this.loadPosts(),
      error: (err) => alert('Error al cancelar: ' + (err.error?.message || err.message))
    });
  }

  deletePost(post: SocialPost): void {
    if (!confirm('¿Borrar esta publicación?')) return;
    this.socialService.deletePost(post.postId).subscribe({
      next: () => this.loadPosts(),
      error: (err) => alert('Error al borrar: ' + (err.error?.message || err.message))
    });
  }

  retryTarget(targetId: number): void {
    this.socialService.retryTarget(targetId).subscribe({
      next: () => setTimeout(() => this.loadPosts(), 1000),
      error: (err) => alert('Error al reintentar: ' + (err.error?.message || err.message))
    });
  }

  canEdit(post: SocialPost): boolean {
    return post.status === 'DRAFT' || post.status === 'SCHEDULED';
  }

  canCancel(post: SocialPost): boolean {
    return post.status === 'SCHEDULED';
  }

  canDelete(post: SocialPost): boolean {
    return post.status !== 'PUBLISHED' && post.status !== 'PUBLISHING';
  }

  getStatusClass(status: PostStatus): string {
    return 'status-' + status.toLowerCase();
  }

  getStatusLabel(status: PostStatus): string {
    const map: { [key: string]: string } = {
      DRAFT: 'Borrador',
      SCHEDULED: 'Programado',
      PUBLISHING: 'Publicando...',
      PUBLISHED: 'Publicado',
      FAILED: 'Fallido',
      CANCELLED: 'Cancelado'
    };
    return map[status] || status;
  }

  getPreview(content: string | undefined): string {
    if (!content) return '(sin texto)';
    return content.length > 80 ? content.substring(0, 80) + '...' : content;
  }
  togglePost(postId: number) {
    this.expandedPostId = this.expandedPostId === postId ? null : postId;
  }

  toggle(commentId: string) {
  if (this.expandedComments.has(commentId)) {
    this.expandedComments.delete(commentId);
  } else {
    this.expandedComments.add(commentId);
  }
}
openReplyDialog(comment: any, event?: Event): void {

  event?.stopPropagation();

  const dialogRef = this.dialog.open(SocialReplyDialogComponent,
    {
      width: '600px',
      panelClass: this.theme,
      data: {
        comment
      }
    }
  );

  dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        setTimeout(() => {this.loadPosts();}, 4000);
      }

    });
  }
  deleteComment(comment: any,  event?: Event): void {
    event?.stopPropagation();

    if (!confirm('¿Deseas eliminar este comentario?')) {
      return;
    }
    const payload = {
      network: comment.network,
      commentId: comment.externalId
    };

    this.sseService.apiDeleteWithBody('social/comments/comment',payload)
      .subscribe({
        next: (response) => {
          setTimeout(() => {this.loadPosts();}, 3000);
        },
        error: (error) => {

          console.error(
            'Error eliminando comentario',
            error
          );

        }
      });

  }
  onNetworkChange(value: string | null): void {
  this.selectedNetwork = value || null;
  console.log(this.selectedNetwork);
  this.applyFilters();
}

onDateChange(value: string | null): void {
  this.selectedDate = value || null;
  this.applyFilters();
}
}

